import { useTranslation } from 'react-i18next';
import { DATE_FORMATS } from '@callmart/types';
import ExportToExcelButton from '../Buttons/ExportToExcelButton';
import { getFormattedDateAndTime } from '../../utils/agGridUtils';

const getReductionValue = (reduction, increase) => (increase === false ? reduction * -1 : reduction);

const convertBooleanToIntegerIfExists = (value) => {
    let result = value;
    if (value) {
        result = 1;
    } else if (value === false) {
        result = 0;
    }

    return result;
};

const EventReductionExportButton = ({ recordType, rows, pinnedBottomRowData, start, end }) => {
    const { t } = useTranslation('allDeltas');

    const exportColumnNames = [
        t('field.location'),
        t('field.worktype'),
        t('field.channel'),
        t('field.task'),
        t('field.name'),
        t('field.comment'),
        t('field.dateFrom'),
        t('field.dateTo'),
        t('field.timeFrom'),
        t('field.timeTo'),
        t('field.duration'),
        t('field.reduction'),
        t('field.productive'),
    ];

    const createExcelRowForExportFile = (exportDataRow) => {
        const {
            location,
            worktype,
            name,
            comment,
            startDate,
            endDate,
            startHour,
            endHour,
            duration,
            reduction,
            channel,
            task,
            productive,
        } = exportDataRow;

        return [
            location,
            worktype,
            channel,
            task,
            name,
            comment,
            startDate,
            endDate,
            startHour,
            endHour,
            duration,
            reduction,
            productive,
        ];
    };

    const getExportFileName = () => {
        const startDate = start.format(DATE_FORMATS.ISO_DATE);
        const endDate = end.format(DATE_FORMATS.ISO_DATE);

        const recordName = recordType === 'reduction' ? t('export.reductions') : t('export.events');
        return `${recordName}_${startDate}_${endDate}.xlsx`;
    };

    const getExportData = () => {
        const exportData = [];
        if (pinnedBottomRowData?.length && pinnedBottomRowData?.length > 0) {
            for (const row of rows) {
                if (!row.workingUnitLocations?.length) continue;
                for (const workingUnitLocation of row.workingUnitLocations) {
                    const { location, name, comment, start, end, duration, reduction, productive, increase } = row;
                    const { worktype, channel, task } = workingUnitLocation.workingUnit;
                    const [startDate, startHour] = getFormattedDateAndTime(start);
                    const [endDate, endHour] = getFormattedDateAndTime(end);

                    exportData.push({
                        location: location.code + ' - ' + location.city,
                        worktype: worktype?.worktype,
                        channel: channel?.name,
                        task: task?.name,
                        name,
                        comment,
                        startDate,
                        endDate,
                        startHour,
                        endHour,
                        duration,
                        reduction: getReductionValue(reduction, increase),
                        productive: convertBooleanToIntegerIfExists(productive),
                    });
                }
            }

            exportData.push({
                // worktypeName holds the "Total" label — neither caller sets a locationCity.
                location: pinnedBottomRowData[0].worktypeName,
                duration: pinnedBottomRowData[0].duration,
                // NOT the German-pinned formatPercentFixed2: this cell goes into an export file the
                // client parses, and it has always read "33135.10 %". Localizing it turned that into
                // "101.814,41 %", which a parser splitting on "." reads back as 101.814. An export is
                // an interface, not UI, so it keeps the format it shipped with (CALL-796).
                reduction: `${pinnedBottomRowData[0].reduction.toFixed(2)} %`,
            });
        }
        return exportData;
    };

    return (
        <ExportToExcelButton
            columnNames={exportColumnNames}
            sheetName="Tabelle1"
            getFileName={getExportFileName}
            wbTitle="Data"
            wbSubject="Export Data"
            createRowFromExportData={createExcelRowForExportFile}
            getExportData={getExportData}
        />
    );
};

export default EventReductionExportButton;
